import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { getPost } from "../../api/blog";
import { useAppStore } from "../../store/useAppStore";
import { postBodyHtml } from "../../utils/sanitizeHtml";
import { t } from "../../utils/utils";
import { PostMeta } from "./PostMeta";
import "./blog.css";

export function BlogPost() {
  const { id } = useParams();
  const { appLang } = useAppStore();
  const [post, setPost] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    getPost(id)
      .then((data) => !cancelled && setPost(data))
      .catch((error) => {
        if (!cancelled) {
          setError(error.status === 404 ? "postNotFound" : "blogLoadError");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return (
    <div className="blog cont1">
      <Link to="/blog" className="blogBack">
        ← {t.backToBlog}
      </Link>

      {error && <div className="blogMessage">{t[error]}</div>}

      {post && (
        <article>
          <PostMeta post={post} appLang={appLang} />
          <h1 className="head1 blogPostTitle">{post.title}</h1>
          <div
            className="blogBody"
            dangerouslySetInnerHTML={{ __html: postBodyHtml(post.body) }}
          />
        </article>
      )}
    </div>
  );
}
